import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ConfigService, Post } from '@speedy/core';
@Injectable({
  providedIn: 'root',
})
export class UsefulService {
  private readonly apiUrl: string = this.configService.get('expressApiUrl');

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {}

  /**
   * Retrieves a category by its URL key.
   * @param url_key - The URL key of the category.
   * @returns An Observable that resolves to a Category object.
   */
  getCategoryByUrlKey(url_key: string): Observable<any> {
    const url = `${this.apiUrl}blog/categories/urlKey/${url_key}`;

    return this.http.get<any>(url);
  }

  /**
   * Retrieves posts by their IDs.
   * @param ids - The IDs of the posts.
   * @returns An Observable that resolves to an array of Post objects.
   */
  getPostsByIds(ids: string): Observable<Post[]> {
    const url = `${this.apiUrl}blog/postsByIds`;
    const body = { ids };

    return this.http.post<Post[]>(url, body);
  }

  /**
   * Retrieves posts by their category.
   * @param ids - The IDs of the posts.
   * @returns An Observable that resolves to an array of Post objects.
   */
  getPostsByCategory(id: string): Observable<Post[]> {
    const url = `${this.apiUrl}blog/categories/${id}/posts`;

    return this.http.get<Post[]>(url);
  }

  /**
   * Retrieves a post by its URL key.
   * @param url_key - The URL key of the post.
   * @returns An Observable that resolves to a Post object.
   */
  getPost(url_key: number): Observable<Post> {
    const url = `${this.apiUrl}blog/posts/url-key/${url_key}`;

    return this.http.get<Post>(url);
  }

  /**
   * Retrieves products associated with a specific post.
   *
   * @param id - The ID of the post for which to retrieve the associated products.
   * @returns An Observable that resolves to an unknown type. The emitted value represents the products associated with the specified post.
   */
  getPostProducts(id: number): Observable<any> {
    const url = `${this.apiUrl}blog/posts/${id}/products`;

    return this.http.get<any>(url);
  }

  /**
   * Sets the media URLs for a given post object.
   * @param post - The post object for which the media URLs need to be set.
   * @returns The post object with the media URLs set.
   */
  setPostMedia(post: Post): Post {
    const MEDIA_POST_URL = 'mageplaza/blog/post/';
    const MEDIA_POST_THUMB_URL = 'resized/100/';
    const placeholder = this.configService.getPlaceholder();

    const mutatedPost = { ...post };

    if (mutatedPost.image === null) {
      mutatedPost.image = placeholder;
      mutatedPost.image_thumb = placeholder;
    } else {
      mutatedPost.image_thumb = `${this.configService.mediaUrl}${MEDIA_POST_THUMB_URL}${mutatedPost.image}`;
      mutatedPost.image = `${this.configService.mediaUrl}${MEDIA_POST_URL}${mutatedPost.image}`;
    }

    return mutatedPost;
  }
}
